module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "justify-center": ""
    }
  }, [_c('item-list', {
    attrs: {
      "allowAdd": "",
      "allowDelete": "",
      "endpoint": _vm.endpoint + 'organizations',
      "editRoute": "organizationEdit",
      "headers": _vm.headers,
      "name": "Organization",
      "searchBarText": _vm.searchBarText,
      "permissions": "organizations"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62497e24","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organizations.vue
// module id = 430
// module chunks = 1